import { z } from 'zod';

import { client } from '~shared/api';

import { DeviceDto, DeviceDtoScheme } from '../model/dto.ts';

export async function fetchSectionDevices(section_id: number): Promise<DeviceDto[]> {
	const data = await client.get(`/device/section/${section_id}`);
	return z.array(DeviceDtoScheme).parse(data);
}

export async function saveSectionDevices(section_id: number, devices: Partial<DeviceDto>[]) {
	await client.post(`/device/section/${section_id}`, devices);
}

export async function getDevice(number: string): Promise<DeviceDto> {
	const data = await client.get(`/device/number/${number}`);
	return DeviceDtoScheme.parse(data);
}
